import React from "react";
import { TUserCaseUserTypePartyGroupTone } from "../../../../domain/codecs/UserCaseUserType";
import { requireExhaustive } from "../../../../shared/src/util";
import { THexColor } from "../../models/StringLiterals";
import { CRMColors } from "../../models/CRMColors";
import { CRMFontSizes } from "../../models/CRMFontSizes";
import { CRMSpacing } from "../../models/CRMSpacing";
import { TFontWeightNumeric } from "../../models/TCRMFontWeight";
import { Background } from "../BuildingBlocks/Background";
import { FontQuicksand } from "../BuildingBlocks/FontQuicksand";
import { Shape } from "../BuildingBlocks/Shape";
import { SpacingRow } from "../BuildingBlocks/SpacingRow";
import { Text } from "../BuildingBlocks/Text";
import { Uppercase } from "../Uppercase/Uppercase";

type TCRMPartyGroupHeadingProps = {
    label: string;
    count: number;
    tone: TUserCaseUserTypePartyGroupTone;
};

const BOLD: TFontWeightNumeric = 700;

const toneBarColour = (tone: TUserCaseUserTypePartyGroupTone): THexColor =>
    tone === "acting" ? CRMColors.PRIMARY_6
    : tone === "money" ? CRMColors.HIGHLIGHTS_POSITIVE_GREEN_6
    : tone === "passive" ? CRMColors.NEUTRAL_6
    : tone === "needs_attention" ? CRMColors.HIGHLIGHTS_INSTRUCTIONAL_BRICK_0
    : requireExhaustive(tone);

const toneTextColour = (tone: TUserCaseUserTypePartyGroupTone): THexColor =>
    tone === "needs_attention"
        ? CRMColors.HIGHLIGHTS_INSTRUCTIONAL_BRICK_0
        : CRMColors.NEUTRAL_2;

export const CRMPartyGroupHeading = (props: TCRMPartyGroupHeadingProps): JSX.Element =>
    <SpacingRow spacing={CRMSpacing.TINY} alignItems="center">
        <Shape
            width="3px"
            height="13px"
            borderRadius="2px"
            color={toneBarColour(props.tone)}
        />

        <FontQuicksand>
            <Text
                size={CRMFontSizes.X_SMALL}
                lineHeight={1}
                weight={BOLD}
                color={toneTextColour(props.tone)}
                letterSpacing="1px"
            >
                <Uppercase>
                    {props.label}
                </Uppercase>
            </Text>
        </FontQuicksand>

        <Background
            color={CRMColors.NEUTRAL_12}
            borderRadius="9px"
            padding="1px 7px"
            width="fit-content"
        >
            <FontQuicksand>
                <Text
                    size={CRMFontSizes.X_SMALL}
                    lineHeight={1.4}
                    weight={BOLD}
                    color={CRMColors.NEUTRAL_4}
                >
                    {props.count}
                </Text>
            </FontQuicksand>
        </Background>
    </SpacingRow>;
